import { useTranslation } from "react-i18next";
import config from "utils/globals";
import { ReactComponent as WarningInfo } from "assets/icons/warning-primary-circule.svg";

const Amount = ({ amount }) => {
  const { t } = useTranslation();
  return (
    <div div className="border-b border-gray--7 ">
      <div className="  flex justify-between items-center">
        <span className="body-14px-medium text-gray-0 ">
          {t("pma-onboarding.amount")}:
        </span>
        <span className="h-20px-bold text-gray-4 ">
          {config.numberSeparator(amount)}
          <span className="body-14px-medium">{t("rial")}</span>
        </span>
      </div>
      <div
        className={`flex gap-1 items-center caption-12px-medium my-5 text-gray-0`}
      >
        <WarningInfo className="[&>path]:fill-gray-0" />
        {t("pma-onboarding.complementary-hint")}
      </div>
    </div>
  );
};
export default Amount;
